module.exports = __webpack_public_path__ + "img/img-bc3506.jpg";